import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import {
  contractParkingSpotsDataSchema,
  type contractParkingSpotsData,
} from '../../../common/validations/contractParkingSpotsSchema'

import { get } from 'api/apiClient'

export type IncludeFilter = 'all' | 'own'

export const contractParkingSpotsKey = (
  contractUuid: string,
  include: IncludeFilter = 'all'
) => ['contracts', contractUuid, 'parking-spots', include] as const

const path = (contractUuid: string, include: IncludeFilter) =>
  `${API_ENDPOINTS.CONTRACT_PARKING_SPOTS.replace(':contractUuid', contractUuid)}?include=${include}`

const params = (contractUuid: string, include: IncludeFilter = 'all') => ({
  queryKey: contractParkingSpotsKey(contractUuid, include),
  queryFn: () =>
    get<contractParkingSpotsData>(
      path(contractUuid, include),
      contractParkingSpotsDataSchema
    ),
  staleTime: 0 as const,
})

export const useAPIGetContractParkingSpots = (
  contractUuid: string | undefined,
  include: IncludeFilter = 'all'
) =>
  useQuery<contractParkingSpotsData>({
    ...(params(contractUuid ?? '', include) as ReturnType<typeof params>),
    enabled: Boolean(contractUuid),
  })

export const useAPIGetContractParkingSpotsSuspense = (
  contractUuid: string,
  include: IncludeFilter = 'all'
) =>
  useSuspenseQuery<contractParkingSpotsData>(
    params(contractUuid, include) as ReturnType<typeof params>
  )
